import React, { useState } from "react";
import Hammer from "react-hammerjs";
// import { Form, Input, Checkbox, Button, message } from 'antd'
import _$ from "jquery";
import Turn from "@/extras/turn.min.js";
import utils from "@/utils";
import config from "@/config";

import swipLeftPng from "@/assets/images/phoneHandSwipe.png";
import "./index.scss";

const topNav = [
  { name: "English", eName: "English", code: "english", icon: "icon-yingyu" },
  { name: "中文", eName: "中文", code: "chinese", icon: "icon-zhongwenyuyan" },
  // { name: '音乐', eName: 'Music', code: 'music', icon: 'icon-musicfill'},
  // { name: "浏览", eName: "Look", code: "look", icon: "icon-attention_light" },
  // { name: "点赞", eName: "Like", code: "like", icon: "icon-appreciate_light" },
  // { name: "留言", eName: "Message", code: "message", icon: "icon-liuyan" },
];
const botNav = [
  {
    name: "企业简介",
    eName: "Company profile",
    code: "profile",
    icon: "icon-qiyejianjie",
  },
  {
    name: "极速阅读",
    eName: "Speed reading",
    code: "reading",
    icon: "icon-read",
  },
  { name: "一键拨号", eName: "Dial", code: "dial", icon: "icon-dianhua" },
  // {
  //   name: "二维码分享",
  //   eName: "QR code",
  //   code: "weappCode",
  //   icon: "icon-cascades",
  // },
];
export default class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scale: 1,
      showTip: false,
      showRead: false,
      showCover: false, // 显示上下导航
      showIntr: false, // 显示公司简介
      swipTip: false,
      showDrawer: false, // 显示中间的覆盖层
      showMessage: false, // 显示留言
      language: "chinese",
      list: [],
      resData: {
        phone: "13726221452",
        introduce: `玛雅建材有限公司是一家专业设计、生产和销售各类装饰型材，锁具生产组装的实业公司。公司秉承“以人为本,以质取胜”的经营理念及多年的锁具配件生产和研制经验,雄厚的技术力量,引进世界先进的生产设备与技术采用最新喷砂、拉丝、电泳抛光、着色等工艺。新研发的个系列产品均代表着行业的最新潮流。励翁产品畅销全国各地以及海外多个国家和地区,赢得了广大用户的信赖和一直好评。我们将一如既往的研发更新、更好、更时尚的产品，与各地经销商携手共进、共创美好明天。`,
      },
      messageObj: {
        name: "",
        phone: "",
        message: "",
      },
    };
    this.x = 0;
    this.y = 0;
  }
  componentWillMount() {
    Turn(_$);
  }
  async componentDidMount() {
    this.initList();
    setTimeout(() => {
      this.initTurn();
      if (!window.localStorage.getItem("swipTip")) {
        this.setState({ swipTip: true });
        window.localStorage.setItem("swipTip", "1");
      }
    }, 800);
  }
  componentWillUnmount() {
    this.x = null;
    this.y = null;
  }

  initList() {
    const { code, number } = this.props.match.params;
    const _list = [];
    for (let i = 1; i <= Number(number || 1); i++) {
      _list.push({
        uid: i,
        url: `/${code}/${i}.jpg`,
      });
    }
    this.setState({
      list: _list,
    });
  }

  // 初始化画册
  async initTurn() {
    const _this = this;
    const { list } = this.state;
    if (!list.length) return;
    const imgObj = await this.getImgWH(list[0].url);
    let winW = window.innerWidth;
    let h = imgObj.h / (imgObj.w / winW);

    _$(".book-wrap").turn({
      width: winW,
      height: h,
      elevation: 50,
      gradients: true,
      pages: list.length,
      autoCenter: true,
      display: "single",
      acceleration: true,
      when: {
        turning: function (event, page, view) {},
        turned: function (event, page, view) {
          if (page === list.length) {
            _this.setState(
              {
                showTip: true,
              },
              () => {
                setTimeout(() => {
                  _this.setState({ showTip: false });
                }, 3000);
              },
            );
            return;
          }
        },
        missing: function (event, pages) {},
      },
    });
  }
  // 获取图片宽高
  async getImgWH(url) {
    let img = new Image();
    img.src = url;
    let obj = {
      w: 0,
      h: 0,
    };
    // 判断是否有缓存
    if (img.complete) {
      obj.w = img.width;
      obj.h = img.height;
      return obj;
    } else {
      // 加载完成执行
      return new Promise((resolve, reject) => {
        img.onload = () => {
          obj = {
            w: img.width,
            h: img.height,
          };
          resolve(obj);
        };
      }).then((res) => res);
    }
  }
  // 滑动
  hammerSwipe(e) {
    if (e.deltaX < 0) {
      _$(".book-wrap").turn("next");
    }
    if (e.deltaX > 0) {
      _$(".book-wrap").turn("previous");
    }
  }
  // 缩放
  onPinch(e) {
    let scale = this.state.scale + e.scale - 1;
    if (scale > 3) return;
    _$(".book-wrap").turn("zoom", scale);
  }
  // 缩放结束
  onPinchEnd(e) {
    let scale = this.state.scale + e.scale - 1;
    if (scale < 1) {
      scale = 1;
      _$(".book-wrap").turn("zoom", 1);
      this.x = 0;
      this.y = 0;
      this.setPostion(this.x, this.y);
    }
    this.setState({ scale });
  }
  // 拖动
  onPan(e) {
    if (this.state.scale <= 1) return;
    this.x += e.srcEvent.movementX;
    this.y += e.srcEvent.movementY;
    this.setPostion(this.x, this.y);
  }
  // 拖动结束
  onPanEnd(e) {
    if (this.state.scale <= 1) return;
    if (this.x > 0) this.x = 0;
    let maxW = -(window.innerWidth * this.state.scale - window.innerWidth); // 宽度 * 倍数 - 宽度
    if (this.x < maxW) this.x = maxW;
    this.setPostion(this.x, this.y);
  }
  setPostion(x, y) {
    _$(".book-wrap").transform(`translate3d(${this.x}px, ${this.y}px, 0px)`);
  }
  // 点击图片
  onTap(e) {
    const { type = "" } = utils.getUrlQuery();
    if (type === "preview") return; // 预览模式
    // 发送给小程序
    // wx.miniProgram.postMessage({ data: 'h5过来的' })
    e.stopPropagation();
    let showCover = !this.state.showCover;
    this.setState({
      showCover,
    });
  }
  //双击
  onDoubleTap(e) {
    // console.log('wx', wx)
  }
  // 遮罩点击
  handleCover(e) {
    e.stopPropagation();
    // const { showCover } = this.state
    // if(!showCover) return
    // this.closeAll()
  }
  // 遮罩拖动
  moveCover(e) {
    e.stopPropagation();
  }
  // 上导航点击
  handleTopNav(e, item) {
    e.stopPropagation();
    switch (item.code) {
      case "english":
        this.setState({ language: "english" });
        break;
      case "chinese":
        this.setState({ language: "chinese" });
        break;
      case "music":
        break;
      case "message":
        let showMessage = !this.state.showMessage;
        this.closeCent();
        this.setState({
          showMessage,
          showDrawer: showMessage,
        });
        break;
    }
  }
  // 下导航点击
  handleBotNav(e, item) {
    e.stopPropagation();
    switch (item.code) {
      case "profile":
        let showIntr = !this.state.showIntr;
        this.closeCent();
        this.setState({ showDrawer: showIntr, showIntr });
        break;
      case "reading":
        let showRead = !this.state.showRead;
        this.closeCent();
        this.setState({ showDrawer: showRead, showRead });
        break;
    }
  }
  // 极速阅读跳转页面
  toPage(e, item, index) {
    e.stopPropagation();
    let page = index + 1;
    _$(".book-wrap").turn("page", page);
    this.closeAll();
  }

  //关闭所有显示
  closeAll() {
    this.closeCent();
    this.setState({
      showCover: false,
    });
  }
  // 关闭中间层的内容
  closeCent() {
    this.setState({
      showDrawer: false,
      showRead: false,
      showIntr: false,
      showMessage: false,
    });
  }

  // 提交留言
  sublimeMessage(e) {
    e.stopPropagation();
    const { messageObj } = this.state;
    let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (!messageObj.name) {
      // 请输入昵称
    } else if (!messageObj.phone) {
      // showToast('请填写手机号码')
    } else if (!myreg.test(messageObj.phone)) {
      // showToast('请填写正确的手机号码')
    } else if (!messageObj.message) {
      // 请填写留言
    }
  }
  changeInputVal(code, e) {
    let messageObj = this.state.messageObj;
    messageObj[code] = e.target.value;
    this.setState({ messageObj });
  }

  render() {
    const {
      list,
      swipTip,
      showTip,
      showRead,
      showIntr,
      showCover,
      language,
      resData,
      showDrawer,
      showMessage,
    } = this.state;
    const bookBodyStyle = {};
    if (resData.bgImage && resData.bgImage.length) {
      if (resData.bgImage[0].response && resData.bgImage[0].response.data) {
        bookBodyStyle.backgroundImage = `url(${config.baseUrl}${resData.bgImage[0].response.data[0].url})`;
      } else {
        bookBodyStyle.backgroundImage = `url(${resData.bgImage[0].url})`;
      }
    }

    return (
      <div
        className="book-body"
        style={bookBodyStyle}>
        <Hammer
          options={{
            recognizers: {
              pinch: { enable: true },
            },
          }}
          onSwipe={this.hammerSwipe.bind(this)}
          onPinch={this.onPinch.bind(this)}
          onPinchEnd={this.onPinchEnd.bind(this)}
          onPan={this.onPan.bind(this)}
          onPanEnd={this.onPanEnd.bind(this)}
          // onTap={this.onTap.bind(this)}
          onDoubleTap={this.onDoubleTap.bind(this)}>
          <div
            className="book-main"
            onClick={(e) => {
              this.onTap(e);
            }}>
            <div className="book-wrap">
              {list.map((item) => (
                <div
                  className="book-li"
                  key={item.uid}
                  style={{ backgroundImage: `url(${item.url})` }}></div>
              ))}
            </div>
          </div>
        </Hammer>
        {showCover && (
          <div
            className="cover-wrap"
            onClick={(e) => {
              this.handleCover(e);
            }}
            onTouchMove={(e) => {
              this.moveCover(e);
            }}>
            <div className="top-wrap">
              <ul className="top-ul">
                {topNav.map(
                  (h) =>
                    language !== h.code && (
                      <li
                        className="top-li"
                        key={h.code}
                        onClick={(e) => this.handleTopNav(e, h)}>
                        <span className="icon-wrap">
                          <i className={`iconfont ${h.icon}`}></i>
                        </span>
                        <span className="label-txt">
                          {language === "chinese" ? h.name : h.eName}
                        </span>
                      </li>
                    ),
                )}
              </ul>
            </div>
            {showDrawer && (
              <div className="cen-wrap">
                {showRead && (
                  <div className="read-wrap">
                    <ul className="cen-ul">
                      {list.map((h, i) => (
                        <li
                          className="cen-li"
                          key={h.uid}
                          style={{ backgroundImage: `url(${h.url})` }}
                          onClick={(e) => {
                            this.toPage(e, h, i);
                          }}>
                          <span className="li-num">{i + 1}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {showIntr && (
                  <div className="intr-wrap">
                    <div
                      dangerouslySetInnerHTML={{ __html: resData.introduce }}
                    />
                  </div>
                )}
                {showMessage && (
                  <div className="message-wrap">
                    <div className="message-ul">
                      <div className="message-list">
                        <span className="message-label">昵称：</span>
                        <div className="message-value">
                          <input
                            className="message-input"
                            value={this.state.messageObj.name}
                            onChange={this.changeInputVal.bind(this, "name")}
                          />
                        </div>
                      </div>
                      <div className="message-list">
                        <span className="message-label">电话：</span>
                        <div className="message-value">
                          <input
                            className="message-input"
                            value={this.state.messageObj.phone}
                            onChange={this.changeInputVal.bind(this, "phone")}
                          />
                        </div>
                      </div>
                      {/* <div className="message-list">
                        <span className="message-label">留言：</span>
                        <div className="message-value">
                          <textarea
                            className="message-area"
                            value={this.state.messageObj.message}
                            onChange={this.changeInputVal.bind(this, "message")}
                          />
                        </div>
                      </div> */}
                    </div>
                    <div className="btn-wrap">
                      <button
                        className="btn"
                        onClick={(e) => {
                          this.sublimeMessage(e);
                        }}>
                        提交
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
            <div className="bot-wrap">
              <div className="nav-wrap">
                <ul className="nav-ul">
                  {botNav.map((h) => (
                    <li
                      className="nav-li"
                      key={h.code}
                      onClick={(e) => this.handleBotNav(e, h)}>
                      {h.code === "dial" ? (
                        <a
                          className="nav-icon"
                          href={`tel:${resData?.phone}`}>
                          <i className={`iconfont ${h.icon}`}></i>
                        </a>
                      ) : (
                        <span className="nav-icon">
                          <i className={`iconfont ${h.icon}`}></i>
                        </span>
                      )}
                      <span className="nav-txt">
                        {language === "chinese" ? h.name : h.eName}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )}
        {showTip && (
          <div className="tip-wrap">
            <span className="tip">这是最后一页</span>
          </div>
        )}
        {swipTip && (
          <div
            className="swip-tip-con"
            onClick={() => this.setState({ swipTip: false })}>
            <div className="swip-left">
              <img
                className="swip-left-img"
                src={swipLeftPng}
                alt=""
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
